// extracted by mini-css-extract-plugin
module.exports = {"slBuoyMap":"BuoyMap_slBuoyMap__NQRXC","slMapLinks":"BuoyMap_slMapLinks__2cv0p","slMapLinksHasBuoys":"BuoyMap_slMapLinksHasBuoys__ugCbO"};